import { Link } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { type Contact, type ContactSuggestion } from '@kontor/shared';
import { api, queryString } from '../../api';
import { useSession } from '../../session';
import './contacts.css';

/**
 * Hinweis auf der Karte eines Kontakts: Gibt es Kontakte derselben Art mit gleicher E-Mail-Adresse oder Telefonnummer, stehen sie hier mit der
 * Schaltfläche zum Zusammenführen (KON-049). Ohne Treffer erscheint nichts.
 */
export function ContactDuplicates({ contact }: { contact: Contact }) {
  const { can } = useSession();
  const found = useQuery({
    queryKey: ['contact-duplicates', { for: contact.id, email: contact.email, phone: contact.phone }],
    queryFn: async () => (await api<{ data: ContactSuggestion[] }>('GET', `/contacts/suggestions${queryString({ email: contact.email ?? undefined, phone: contact.phone ?? undefined, excludeId: contact.id })}`)).data,
    enabled: !!contact.email || !!contact.phone,
  });
  // Person und Firma lassen sich nicht zusammenführen, deshalb nur Kontakte derselben Art anbieten
  const same = (found.data ?? []).filter((c) => c.kind === contact.kind);
  if (same.length === 0) return null;

  return (
    <section className="card duplicate-card" aria-label="Mögliche Dubletten">
      <h2>Mögliche Dubletten</h2>
      <p className="muted small">Diese Kontakte haben dieselbe E-Mail-Adresse oder Telefonnummer wie {contact.name}.</p>
      <ul className="contact-options">
        {same.map((c) => (
          <li key={c.id}>
            <span className="contact-options__who">
              <Link to={`/kontakte/${c.id}`} className="strong-link">{c.name}</Link>
              <span className="muted small"> · {c.matchedBy.map((m) => (m === 'email' ? 'gleiche E-Mail-Adresse' : 'gleiche Telefonnummer')).join(' und ')}</span>
            </span>
            {can('contacts.write') && <Link className="btn btn--secondary btn--sm" to={`/kontakte/${contact.id}/zusammenfuehren?mit=${c.id}`}>Zusammenführen</Link>}
          </li>
        ))}
      </ul>
    </section>
  );
}
